<div class="configured-report-dashboard-config" *ngIf="config">
  <div dwRow>
    <div dwCol="12">
      <label>Dashboard Group <span class="text-danger">*</span></label>
      <select class="form-control"
        [ngModel]="config.dashboardGroupKey"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="selectDashboardGroup($event)"
        [disabled]="loading || !!loadError">
        <option [ngValue]="null">Select a dashboard group</option>
        <option *ngFor="let group of dashboardGroups" [ngValue]="group.DashboardGroupKey">
          {{ group.DashboardGroupDisplay }} ({{ group.DashboardGroupKey }}){{ group.IsActive === false ? ' — Inactive' : '' }}
        </option>
      </select>
      <small class="form-text text-muted">
        The selected value is stored as componentConfig.dashboardGroupKey.
      </small>
    </div>
  </div>

  <div class="text-muted mt-2" *ngIf="loading">
    <i class="fa fa-spinner fa-spin"></i> Loading dashboard groups...
  </div>

  <div class="alert alert-warning mt-2 mb-0" *ngIf="selectedGroupMissing">
    Dashboard group <strong>{{ config.dashboardGroupKey }}</strong> does not exist. Select an available group before saving.
  </div>

  <div class="alert alert-warning mt-2 mb-0" *ngIf="selectedGroupInactive">
    Dashboard group <strong>{{ config.dashboardGroupKey }}</strong> is inactive and will not load at runtime.
  </div>

  <div class="alert alert-warning mt-2 mb-0" *ngIf="loadError">
    {{ loadError }} The existing dashboard group key has been retained.
  </div>
</div>
